import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'

import Button from '../Button/Button'
import ArrowIcon from '../../images/icons/arrow-down-black.svg'

export const StyledCapacitiesCollapse = styled.div`
  flex-direction: column;
  display: flex;
  margin-bottom: ${pxToRem(1)};
`

export const StyledContent = styled.div`
  padding: ${pxToRem(20)};
  background-color: ${({ theme }) => theme.colors.unique.white};
`

export const StyledRichText = styled.div`
  margin-bottom: ${pxToRem(5.5)};
`

export const StyledButtonsContainer = styled.div`
  flex-wrap: wrap;
  justify-content: space-evenly;
  display: flex;
`

export const StyledButton = styled(Button)`
  justify-content: space-between;
  display: flex;
  width: 100%;
  margin: initial;
  padding: ${pxToRem(15)} 0;
  background-color: ${({ theme }) => theme.colors.unique.white};
  border-bottom: ${({ $active, theme }) =>
    $active && `solid ${pxToRem(2)} ${theme.colors.primary.blue}`};
`

export const StyledLabel = styled.span`
  margin-left: ${pxToRem(20.5)};
  font-weight: ${({ theme }) => theme.fonts.weight.medium};
`

export const StyledIcon = styled(ArrowIcon)`
  margin-right: ${pxToRem(27.25)};
  width: ${pxToRem(10.5)};
  height: ${pxToRem(6)};
  transform: ${({ $active }) => $active && 'rotate(180deg)'};
`
